module.exports = __webpack_public_path__ + "static/flags/KU-e8d234314864bd8146013ba3c933fac8.gif";